import { ofType } from "redux-observable";
import * as Rx from "rxjs";
import * as RxOp from "rxjs/operators";

import { OPEN_PAYMENT, requestGetPayment } from "../Payment.state";
import { history } from "@/util/history";

const PAYMENT_PATH = "/payment/";

const openPaymentEpic = (action$) =>
  action$.pipe(
    ofType(OPEN_PAYMENT),
    RxOp.mergeMap(({ payload: { transactionId } }) => {
      history.push({
        pathname: `${PAYMENT_PATH}${transactionId}`,
      });
      const shouldRequest = history.location.pathname.startsWith(PAYMENT_PATH);
      return shouldRequest ? Rx.of(requestGetPayment()) : Rx.empty();
    })
  );

export default openPaymentEpic;
